import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Typography, TextField, Stack, Avatar, FormControlLabel, Checkbox , Tooltip} from '@mui/material';
import { SquareRow, SquareRowDetail } from './squareRow'
import moment from 'moment';

const fallsInDate = (dateToCheck, startDate, endDate) => {
    dateToCheck = moment(dateToCheck, 'DD-MM-YYYY')
    startDate = moment(startDate, 'DD-MM-YYYY')
    endDate = moment(endDate, 'DD-MM-YYYY')
    return dateToCheck.isBetween(startDate, endDate, undefined, '[]');
  }
const DetailViewPopUp = ({open, handleClose, selectedProduct, date, bookings}) => {
    if (selectedProduct) {
    const relventBookings = bookings.filter(booking => {
        return fallsInDate(moment(date, "DD-MM-YYYY").subtract(1 ,'days').format('DD-MM-YYYY')), moment(booking.from).format("DD-MM-YYYY"), moment(booking.to).format("DD-MM-YYYY")
      })
    return (
        <Dialog sx={{height:{xs:'90vh', sm:'90vh'}}} onClose={handleClose} fullWidth={true}
        maxWidth={"md"} aria-labelledby="customized-dialog-title" open={open}>
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                <Stack direction="row" alignItems="center"><Typography sx={{mr: 2}}>{selectedProduct?.name}</Typography><img src={selectedProduct?.image?.thumb} height="50"/></Stack>
            </DialogTitle>
            <DialogContent sx={{height:{xs:'90vh', sm:'90vh'}}} dividers style={{height: '100%'}}>
                <Stack direction="column" spacing={0.25}>
                    {selectedProduct.itemsDetail.map(item => <SquareRowDetail isMobile={false} key={item._id} item={item._id} sku={item.sku} date={date} bookings={relventBookings}/>)}
                    {<Stack direction="row"><Typography sx={{ mr: 2, overflow: 'hidden', visibility: "hidden", fontSize: 12 }}>{selectedProduct.itemsDetail[0].sku}</Typography><SquareRowDetail key={`${selectedProduct._id}-hour-row`} date={date}/></Stack>}
                </Stack>
            </DialogContent>
            <DialogActions>

            </DialogActions>
        </Dialog>
    )
    }
}

export default DetailViewPopUp;